import type { FrameGrabber } from '../../../stream/ambientLight/FrameGrabber';

export class CanvasMirrorRenderer {
  private context: CanvasRenderingContext2D;
  private frameRequest: number | undefined;
  private requestVideoFrameCallbackSupported = false;

  constructor(
    private grabber: FrameGrabber,
    canvas: HTMLCanvasElement,
    private videoElement: HTMLVideoElement
  ) {
    const canvasContext = canvas.getContext('2d', {
      desynchronized: true,
    });
    if (!canvasContext) {
      throw new Error('Failed to get canvas context');
    }
    this.context = canvasContext;

    this.requestVideoFrameCallbackSupported = 'requestVideoFrameCallback' in videoElement;
  }

  requestFrameCallback(callback: () => void): void {
    if (this.requestVideoFrameCallbackSupported) {
      this.frameRequest = this.videoElement.requestVideoFrameCallback(callback);
    } else {
      this.frameRequest = window.requestAnimationFrame(callback);
    }
  }

  cancelFrameCallback(frameRequest: number): void {
    if (this.requestVideoFrameCallbackSupported) {
      this.videoElement.cancelVideoFrameCallback(frameRequest);
    } else {
      window.cancelAnimationFrame(frameRequest);
    }
  }

  drawLoop(): void {
    const frameSource = this.grabber.grabFrameSource();
    if (frameSource) {
      this.context.drawImage(frameSource, 0, 0, this.context.canvas.width, this.context.canvas.height);
    }
    this.requestFrameCallback(this.drawLoop.bind(this));
  }

  start(): void {
    this.drawLoop();
  }

  destroy(): void {
    if (this.frameRequest) {
      this.cancelFrameCallback(this.frameRequest);
    }
  }
}
